import type { PlaybookPortfolioEarned } from '@/types/playbooks';

export interface PlaybookPortfolioStory {
  headline: string;
  detail: string;
}

/** Program-level receipts only: exact shipped pages, current citing answers,
 * and source-attributed claims. No before/after or causal estimate belongs in
 * this summary; those stay on each playbook's Impact view. */
export function playbookPortfolioStory(
  earned: PlaybookPortfolioEarned | null | undefined,
): PlaybookPortfolioStory | null {
  if (!earned || earned.pages_shipped <= 0 || earned.pages_cited <= 0 || earned.citations_earned <= 0) return null;

  const pageNoun = earned.pages_cited === 1 ? 'page' : 'pages';
  const answerNoun = earned.citations_earned === 1 ? 'answer' : 'answers';
  const claimNoun = earned.positive_claims === 1 ? 'positive claim' : 'positive claims';

  return {
    headline: `${earned.pages_cited} published ${pageNoun} ${earned.pages_cited === 1 ? 'is' : 'are'} now cited by AI.`,
    detail: `${earned.citations_earned.toLocaleString()} current citing ${answerNoun} · ${earned.positive_claims.toLocaleString()} ${claimNoun} backed`,
  };
}
